import { render, staticRenderFns } from "./pharmaFiled.vue?vue&type=template&id=68279cd4&scoped=true&"
import script from "./pharmaFiled.vue?vue&type=script&lang=ts&"
export * from "./pharmaFiled.vue?vue&type=script&lang=ts&"
import style0 from "./pharmaFiled.vue?vue&type=style&index=0&id=68279cd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68279cd4",
  null
  
)

export default component.exports